// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0.5rem !important;
}
.p-button.p-button-icon-only.p-button-rounded {
  height: 2rem !important;
}
.p-button.p-button-icon-only {
  width: 2rem !important;
}
.p-toolbar {
  padding: 0.5rem !important;
}
.card {
  padding: 1rem !important;
}
.field {
  margin-bottom: 0 !important;
}
.p-button.p-button-icon-only {
  padding: 0.5rem 0 !important;
}

.blue-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--blue-500);
}
.blue-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--blue-500);
}
.green-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--green-500);
}
.green-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--green-500);
}
.yellow-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--yellow-500);
}
.yellow-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--yellow-500);
}
.cyan-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--cyan-500);
}
.cyan-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--cyan-500);
}
.pink-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--pink-500);
}
.pink-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--pink-500);
}
.indigo-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--indigo-500);
}
.indigo-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--indigo-500);
}
.teal-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--teal-500);
}
.teal-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--teal-500);
}
.bluegray-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--bluegray-500);
}
.bluegray-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--bluegray-500);
}
.purple-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--purple-500);
}
.purple-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--purple-500);
}

.p-treeselect-token {
  display: none !important;
}

.p-timeline-event-opposite {
  display: none !important;
}

.change-disabled .p-disabled,
.change-disabled .p-component:disabled {
  background-color: #f2f2f2 !important;
  opacity: 1 !important;
}

@media print {
  body {
    margin: 0 !important;
  }
}

.main-container {
  --ckeditor5-preview-height: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 8px;
}

.ck-content {
  line-height: 1.6;
  word-break: break-word;
}

.editor-container__editor-wrapper {
  display: flex;
  width: 100%;
}

.editor-container_document-editor {
  border: 1px solid var(--ck-color-base-border);
}

.editor-container_document-editor .editor-container__toolbar {
  display: flex;
  position: relative;
  box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);
}

.editor-container_document-editor .editor-container__toolbar > .ck.ck-toolbar {
  flex-grow: 1;
  width: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}

.editor-container_document-editor
  .editor-container__menu-bar
  > .ck.ck-menu-bar {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}

.editor-container_document-editor .editor-container__editor-wrapper {
  max-height: var(--ckeditor5-preview-height);
  min-height: var(--ckeditor5-preview-height);
  overflow-y: scroll;
  background: var(--ck-color-base-foreground);
  display: flex;
  justify-content: center;
}

.editor-container_document-editor .editor-container__editor {
  margin-top: 28px;
  margin-bottom: 28px;
  height: 100%;
}

.editor-container_document-editor
  .editor-container__editor
  .ck.ck-editor__editable {
  box-sizing: border-box;
  min-width: calc(210mm + 2px);
  max-width: calc(210mm + 2px);
  min-height: 297mm;
  height: fit-content;
  /* padding: 20mm 12mm; */
  border: 1px hsl(0, 0%, 82.7%) solid;
  background: hsl(0, 0%, 100%);
  box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);
  flex: 1 1 auto;
  margin-left: 72px;
  margin-right: 72px;
}

.ck-content h3.category {
  font-size: 20px;
  font-weight: bold;
  color: #555;
  letter-spacing: 10px;
  margin: 0;
  padding: 0;
}

.ck-content h2.document-title {
  font-size: 50px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  border: 0;
}

.ck-content h3.document-subtitle {
  font-size: 20px;
  color: #555;
  margin: 0 0 1em;
  font-weight: bold;
  padding: 0;
}

.ck-content p.info-box {
  --background-size: 30px;
  --background-color: #e91e63;
  padding: 1.2em 2em;
  border: 1px solid var(--background-color);
  background: linear-gradient(
      135deg,
      var(--background-color) 0%,
      var(--background-color) var(--background-size),
      transparent var(--background-size)
    ),
    linear-gradient(
      135deg,
      transparent calc(100% - var(--background-size)),
      var(--background-color) calc(100% - var(--background-size)),
      var(--background-color)
    );
  border-radius: 10px;
  margin: 1.5em 2em;
  box-shadow: 5px 5px 0 #ffe6ef;
}

.ck-content blockquote.side-quote {
  font-style: normal;
  float: right;
  width: 35%;
  position: relative;
  border: 0;
  overflow: visible;
  z-index: 1;
  margin-left: 1em;
}

.ck-content blockquote.side-quote::before {
  content: "“";
  position: absolute;
  top: -37px;
  left: -10px;
  display: block;
  font-size: 200px;
  color: #e7e7e7;
  z-index: -1;
  line-height: 1;
}

.ck-content blockquote.side-quote p {
  font-size: 2em;
  line-height: 1;
}

.ck-content blockquote.side-quote p:last-child:not(:first-child) {
  font-size: 1.3em;
  text-align: right;
  color: #555;
}

.ck-content span.marker {
  background: yellow;
}

.ck-content span.spoiler {
  background: #000;
  color: #000;
}

.ck-content span.spoiler:hover {
  background: #000;
  color: #fff;
}

.ck-content pre.fancy-code {
  border: 0;
  margin-left: 2em;
  margin-right: 2em;
  border-radius: 10px;
}

.ck-content pre.fancy-code::before {
  content: "";
  display: block;
  height: 13px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin-bottom: 8px;
  background-repeat: no-repeat;
}

.ck-content pre.fancy-code-dark {
  background: #272822;
  color: #fff;
  box-shadow: 5px 5px 0 #0000001f;
}

.ck-content pre.fancy-code-bright {
  background: #dddfe0;
  color: #000;
  box-shadow: 5px 5px 0 #b3b3b3;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;EACpC,qBAAqB;AACvB;;AAIA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;EAC5B,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC;;;;;;;;;;;KAWG;EACH,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mDAA+W;EAC/W,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n.p-datatable .p-datatable-tbody > tr > td {\n  padding: 0.5rem !important;\n}\n.p-button.p-button-icon-only.p-button-rounded {\n  height: 2rem !important;\n}\n.p-button.p-button-icon-only {\n  width: 2rem !important;\n}\n.p-toolbar {\n  padding: 0.5rem !important;\n}\n.card {\n  padding: 1rem !important;\n}\n.field {\n  margin-bottom: 0 !important;\n}\n.p-button.p-button-icon-only {\n  padding: 0.5rem 0 !important;\n}\n\n.blue-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--blue-500);\n}\n.blue-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--blue-500);\n}\n.green-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--green-500);\n}\n.green-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--green-500);\n}\n.yellow-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--yellow-500);\n}\n.yellow-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--yellow-500);\n}\n.cyan-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--cyan-500);\n}\n.cyan-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--cyan-500);\n}\n.pink-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--pink-500);\n}\n.pink-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--pink-500);\n}\n.indigo-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--indigo-500);\n}\n.indigo-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--indigo-500);\n}\n.teal-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--teal-500);\n}\n.teal-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--teal-500);\n}\n.bluegray-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--bluegray-500);\n}\n.bluegray-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--bluegray-500);\n}\n.purple-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--purple-500);\n}\n.purple-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--purple-500);\n}\n\n.p-treeselect-token {\n  display: none !important;\n}\n\n.p-timeline-event-opposite {\n  display: none !important;\n}\n\n.change-disabled .p-disabled,\n.change-disabled .p-component:disabled {\n  background-color: #f2f2f2 !important;\n  opacity: 1 !important;\n}\n@import url(\"https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap\");\n\n@media print {\n  body {\n    margin: 0 !important;\n  }\n}\n\n.main-container {\n  --ckeditor5-preview-height: 700px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 8px;\n}\n\n.ck-content {\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n.editor-container__editor-wrapper {\n  display: flex;\n  width: 100%;\n}\n\n.editor-container_document-editor {\n  border: 1px solid var(--ck-color-base-border);\n}\n\n.editor-container_document-editor .editor-container__toolbar {\n  display: flex;\n  position: relative;\n  box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);\n}\n\n.editor-container_document-editor .editor-container__toolbar > .ck.ck-toolbar {\n  flex-grow: 1;\n  width: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}\n\n.editor-container_document-editor\n  .editor-container__menu-bar\n  > .ck.ck-menu-bar {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}\n\n.editor-container_document-editor .editor-container__editor-wrapper {\n  max-height: var(--ckeditor5-preview-height);\n  min-height: var(--ckeditor5-preview-height);\n  overflow-y: scroll;\n  background: var(--ck-color-base-foreground);\n  display: flex;\n  justify-content: center;\n}\n\n.editor-container_document-editor .editor-container__editor {\n  margin-top: 28px;\n  margin-bottom: 28px;\n  height: 100%;\n}\n\n.editor-container_document-editor\n  .editor-container__editor\n  .ck.ck-editor__editable {\n  box-sizing: border-box;\n  min-width: calc(210mm + 2px);\n  max-width: calc(210mm + 2px);\n  min-height: 297mm;\n  height: fit-content;\n  /* padding: 20mm 12mm; */\n  border: 1px hsl(0, 0%, 82.7%) solid;\n  background: hsl(0, 0%, 100%);\n  box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);\n  flex: 1 1 auto;\n  margin-left: 72px;\n  margin-right: 72px;\n}\n\n.ck-content h3.category {\n  font-size: 20px;\n  font-weight: bold;\n  color: #555;\n  letter-spacing: 10px;\n  margin: 0;\n  padding: 0;\n}\n\n.ck-content h2.document-title {\n  font-size: 50px;\n  font-weight: bold;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.ck-content h3.document-subtitle {\n  font-size: 20px;\n  color: #555;\n  margin: 0 0 1em;\n  font-weight: bold;\n  padding: 0;\n}\n\n.ck-content p.info-box {\n  --background-size: 30px;\n  --background-color: #e91e63;\n  padding: 1.2em 2em;\n  border: 1px solid var(--background-color);\n  background: linear-gradient(\n      135deg,\n      var(--background-color) 0%,\n      var(--background-color) var(--background-size),\n      transparent var(--background-size)\n    ),\n    linear-gradient(\n      135deg,\n      transparent calc(100% - var(--background-size)),\n      var(--background-color) calc(100% - var(--background-size)),\n      var(--background-color)\n    );\n  border-radius: 10px;\n  margin: 1.5em 2em;\n  box-shadow: 5px 5px 0 #ffe6ef;\n}\n\n.ck-content blockquote.side-quote {\n  font-style: normal;\n  float: right;\n  width: 35%;\n  position: relative;\n  border: 0;\n  overflow: visible;\n  z-index: 1;\n  margin-left: 1em;\n}\n\n.ck-content blockquote.side-quote::before {\n  content: \"“\";\n  position: absolute;\n  top: -37px;\n  left: -10px;\n  display: block;\n  font-size: 200px;\n  color: #e7e7e7;\n  z-index: -1;\n  line-height: 1;\n}\n\n.ck-content blockquote.side-quote p {\n  font-size: 2em;\n  line-height: 1;\n}\n\n.ck-content blockquote.side-quote p:last-child:not(:first-child) {\n  font-size: 1.3em;\n  text-align: right;\n  color: #555;\n}\n\n.ck-content span.marker {\n  background: yellow;\n}\n\n.ck-content span.spoiler {\n  background: #000;\n  color: #000;\n}\n\n.ck-content span.spoiler:hover {\n  background: #000;\n  color: #fff;\n}\n\n.ck-content pre.fancy-code {\n  border: 0;\n  margin-left: 2em;\n  margin-right: 2em;\n  border-radius: 10px;\n}\n\n.ck-content pre.fancy-code::before {\n  content: \"\";\n  display: block;\n  height: 13px;\n  background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==);\n  margin-bottom: 8px;\n  background-repeat: no-repeat;\n}\n\n.ck-content pre.fancy-code-dark {\n  background: #272822;\n  color: #fff;\n  box-shadow: 5px 5px 0 #0000001f;\n}\n\n.ck-content pre.fancy-code-bright {\n  background: #dddfe0;\n  color: #000;\n  box-shadow: 5px 5px 0 #b3b3b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
